(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-body]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function render(cart) {
    updateCount(cart.item_count);

    if (!cart.item_count) {
      body.innerHTML =
        '<p class="adv-cart-empty">Your cart is empty.</p>' +
        '<div class="adv-drawer__foot"><a href="/collections/all" class="adv-btn adv-btn--primary" data-cart-close>Continue shopping</a></div>';
      return;
    }

    var lines = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
          : '';
        var variant =
          item.variant_title && item.variant_title.indexOf('Default') === -1
            ? '<div class="adv-cart-line__meta">' + item.variant_title + '</div>'
            : '';
        return (
          '<div class="adv-cart-line">' +
          img +
          '<div class="adv-cart-line__info">' +
          '<a href="' + item.url + '" class="adv-cart-line__title">' + item.product_title + '</a>' +
          variant +
          '<div class="adv-cart-line__meta">Qty ' + item.quantity + ' · ' + money(item.final_line_price) + '</div>' +
          '<button type="button" class="adv-cart-line__remove" data-cart-remove="' + item.key + '">Remove</button>' +
          '</div></div>'
        );
      })
      .join('');

    body.innerHTML =
      '<div class="adv-cart-lines">' + lines + '</div>' +
      '<div class="adv-drawer__foot">' +
      '<div class="adv-cart-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a href="/cart/checkout" class="adv-btn adv-btn--primary">Checkout</a>' +
      '<a href="/cart" class="adv-drawer__viewcart">View cart &amp; more payment options</a>' +
      '</div>';
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  // Open / close
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      refresh().then(open);
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      close();
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeBtn.getAttribute('data-cart-remove'), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(render);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Opened programmatically (e.g. configurator multi-add)
  document.addEventListener('adv:opencart', function () {
    refresh().then(open);
  });

  // Intercept add-to-cart forms so items land in the drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(open);
  });
})();
